export default __webpack_public_path__ + "static/media/calendar.4e53ec1a.svg";